import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = new Map(); // slug → groups (module-level; one fetch per dossier per session)

export const useTopicEntities = (slug) => {
  const [groups, setGroups] = useState(cache.get(slug) || null);
  useEffect(() => {
    if (!slug) return;
    if (cache.has(slug)) { setGroups(cache.get(slug)); return; }
    let gone = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/topics/${slug}/entities`);
        cache.set(slug, data);
        if (!gone) setGroups(data);
      } catch {
        cache.set(slug, {});
        if (!gone) setGroups({});
      }
    })();
    return () => { gone = true; };
  }, [slug]);
  return groups;
};

export const allEntities = (groups) =>
  groups ? [...(groups.people || []), ...(groups.organizations || []), ...(groups.operations || [])] : [];
